import React, { useState } from 'react';
import Layout from '../components/Layout';

const faqs = [
  { q: 'How do I book a flight through Bluejay Travels?', a: 'Submit a Flight Inquiry from the Flight Booking page or Contact Us, and one of our consultants will share the best available fares within a few hours.' },
  { q: 'Do you assist with visa applications?', a: 'Yes — our Visa Assistance service covers document checklists, application support, and appointment scheduling for most major destinations.' },
  { q: 'Can I customise a holiday package?', a: 'Absolutely. Every holiday package is built around your dates, budget, and interests — just share your preferences in the Holiday Package Inquiry form.' },
  { q: 'How will I know my inquiry was received?', a: "You'll get an automatic confirmation email as soon as you submit any form on our site, and a team member will follow up directly." },
  { q: 'Do you offer corporate travel management?', a: 'Yes, our Corporate Travel Services include dedicated account management and policy-compliant booking for businesses of any size.' }
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <Layout>
      <section className="section">
        <div className="container" style={{ maxWidth: 720 }}>
          <span className="eyebrow">Help center</span>
          <h1>Frequently Asked Questions</h1>

          {faqs.map((f, i) => (
            <div key={f.q} className="card" style={{ marginBottom: 12, padding: 0 }}>
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                style={{ width: '100%', textAlign: 'left', padding: 18, background: 'none', border: 'none', fontWeight: 700, fontSize: '1rem', cursor: 'pointer', display: 'flex', justifyContent: 'space-between' }}
              >
                {f.q} <span>{openIndex === i ? '–' : '+'}</span>
              </button>
              {openIndex === i && <p style={{ padding: '0 18px 18px' }}>{f.a}</p>}
            </div>
          ))}
        </div>
      </section>
    </Layout>
  );
}
